// Explore-stats page: Division statistics.
// Recreates the Handbook page — divisions agreed/negatived by Parliament
// (since the 42nd), with a filterable table of recent divisions.

import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatLine } from './charts';

export default function DivisionStatistics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('division-statistics');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const c = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Division statistics"
      description={`House and Senate divisions since the 42nd Parliament${
        c.total ? ` (${c.total} divisions; ${c.shown} most recent in the table)` : ''
      }. Outcomes are derived from the recorded aye/no counts. Use the table's "Split vote" column to spot contested divisions.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="division-statistics"
    >
      {data && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Division outcomes by Parliament
          </Typography>
          <StatLine data={c.outcomes_by_parliament || []} xKey="parliament"
                    keys={['Agreed to', 'Negatived']} />
        </Paper>
      )}
    </ExploreStatsPage>
  );
}
